import { useState } from "react";
import reactStringReplace from "react-string-replace";

import { Spinner } from "@up/ui";

import AddButton from "./AddButton";
import { MoneyTable } from "./MoneyTable";

import { logError } from "@up/data";

import type { TAddon } from "@up/data";

export const AddonLineItem = function AddonLineItem({
  addon,
  addItem,
}: {
  addon: TAddon;
  addItem: (id: string) => void;
}) {
  const [isAdding, setIsAdding] = useState(false);

  const handleAdd = async function () {
    setIsAdding(true);
    try {
      await addItem(addon._id);
      setIsAdding(false);
    } catch (err) {
      setIsAdding(false);
      logError({
        action: "ADDON_ADD_TO_CART",
        error: err,
        context: { addonId: addon._id },
      });
    }
  };

  return (
    <li
      key={addon._id}
      className="checkout-list-item"
      data-testid="checkout-line-item"
      style={{ padding: "0.75rem 0 0.5rem 0" }}
    >
      <div className="checkout-list-item-content items-center">
        <div className="checkout-list-item-title">
          {reactStringReplace(addon.catalogueItem.name, "+Live", (match, i) => (
            <span key={i} className="italic">
              +Live
            </span>
          ))}
          <br />
          <a
            href={addon.scheduleLink ?? "#"}
            className="font-normal underline opacity-75"
            target="_blank"
            rel="noreferrer"
          >
            Learn More
          </a>
        </div>
        <div className="checkout-list-item-money">
          <div>
            <MoneyTable price={addon.formattedRetailPrice} singleRow={true} />
          </div>
        </div>
        <div className="checkout-list-item-remove">
          {isAdding ? <Spinner /> : <AddButton onClick={handleAdd} />}
        </div>
      </div>
    </li>
  );
};
